import PropTypes from "prop-types";
import React from "react";
import { SimpleFetch } from "ui/fetch/simple-fetch";

import { PlayerVersionTable } from "./player-version-table";

function WrappedPlayerVersionsTable(props) {
  return <PlayerVersionTable stats={props.stats && props.stats.body} />;
}

WrappedPlayerVersionsTable.propTypes = {
  stats: PropTypes.object,
};

class PlayerVersionStatsWidget extends React.PureComponent {
  render() {
    return (
      <SimpleFetch.PlayerVersionsStats
        errorChild={<WrappedPlayerVersionsTable />}
      >
        <WrappedPlayerVersionsTable />
      </SimpleFetch.PlayerVersionsStats>
    );
  }
}

export { PlayerVersionStatsWidget };
